import { Component, EventEmitter, Output } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';

@Component({
  selector: 'app-crop-health-map-controls',
  imports: [SharedModule],
  templateUrl: './crop-health-map-controls.component.html',
  styleUrl: './crop-health-map-controls.component.less',
})
export class CropHealthMapControlsComponent {
  @Output() onZoomClick = new EventEmitter();
}
